import React from 'react';
import PropTypes from 'prop-types';

export const IconNoToggle = ({ color, size, ...props }) => {
    // SVG downloaded from Tabler icon library
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={color}
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M 10.465 13.667 C 9.215 15.831 6.091 15.831 4.843 13.667 C 4.557 13.173 4.408 12.614 4.408 12.044 L 4.413 11.853 C 4.5 10.373 5.57 9.171 6.968 8.87 L 5.073 7.279 C 2.541 8.653 1.362 11.969 2.968 14.749 C 3.934 16.424 5.722 17.454 7.654 17.454 L 16.311 17.454 C 16.588 17.454 16.857 17.434 17.119 17.397 L 10.903 12.175 C 10.883 12.676 10.744 13.185 10.465 13.667 Z M 16.311 4.469 C 22.142 4.469 25.787 10.782 22.871 15.831 C 22.634 16.243 22.36 16.628 22.056 16.982 L 20.398 15.592 C 21.816 13.948 22.236 11.484 20.997 9.338 C 20.03 7.664 18.244 6.633 16.311 6.633 L 9.708 6.633 L 7.146 4.486 C 7.314 4.475 7.484 4.469 7.654 4.469 Z M 16.311 19.619 L 7.654 19.619 C 1.822 19.619 -1.823 13.306 1.094 8.256 C 1.662 7.272 2.433 6.446 3.336 5.82 L 2.189 4.856 C 1.754 4.491 1.698 3.842 2.063 3.407 C 2.428 2.973 3.077 2.916 3.512 3.282 L 22.576 19.295 C 23.011 19.66 23.067 20.309 22.702 20.744 C 22.337 21.179 21.689 21.235 21.254 20.87 L 19.121 19.078 C 18.241 19.43 17.289 19.619 16.311 19.619 Z" />
        </svg>
    );
};

IconNoToggle.propTypes = {
    color: PropTypes.string,
    size: PropTypes.number
};

IconNoToggle.defaultProps = {
    color: '#000000',
    size: 24
};
